import { useEffect, useRef } from 'react';

export const useGBPConnectionPolling = (
	pollingForGBPConnection,
	currentShop,
	onShopRefresh,
	setPollingForGBPConnection,
	setGbpError
) => {
	const pollCountRef = useRef(0);
	const maxPolls = 60; // 60 polls * 3 seconds = 3 minutes timeout

	useEffect(() => {
		if (!pollingForGBPConnection) {
			pollCountRef.current = 0;
			return;
		}

		const pollInterval = setInterval(async () => {
			pollCountRef.current++;

			// ⚠️ CRITICAL: Check for 'connected' status specifically
			// Do NOT just check for presence of gmbConnection (could be 'authorised')
			if (currentShop?.gmbConnection?.status === 'connected') {
				setPollingForGBPConnection(false);
				pollCountRef.current = 0;
				return;
			}

			// Timeout after 3 minutes
			if (pollCountRef.current >= maxPolls) {
				setPollingForGBPConnection(false);
				setGbpError('Connection is taking longer than expected. Please refresh the page or contact support.');
				pollCountRef.current = 0;
				return;
			}

			// Refresh shop data to check for updates
			if (onShopRefresh) {
				await onShopRefresh();
			}
		}, 3000); // Poll every 3 seconds

		return () => {
			clearInterval(pollInterval);
		};
	}, [pollingForGBPConnection, currentShop, onShopRefresh, setPollingForGBPConnection, setGbpError, maxPolls]);
};
